/**
 * ⚠️ AUTO-GENERATED FILE - DO NOT EDIT
 *
 * Generated by: sf database-code
 * Generated from database schema
 *
 * To modify: Change the database schema and re-run `sf database-code` (dc)
 */
/* eslint-disable complexity */
import { isObject, hasPropOfType, isArrayOfType, UUID, Temporal, type LocalDatabaseTableDefinition } from 'sf-shared';
import type { UnambiguationBase } from 'shared/dbo/Unambiguation';

export interface UnambiguationIndexedDb {
	id: string;
	consumablePath: string[];
	chosenOption?: string;
	chosenOption__is_null: boolean;
	choiceDate?: string;
	choiceDate__is_null: boolean;
	wholePathOnly: boolean;
	created: number;
	lastModified: number;
	shortId: string;
}

export const isUnambiguationIndexedDb = (obj: unknown): obj is UnambiguationIndexedDb => {
	if (!isObject(obj)) {
		return false;
	}
	if (!hasPropOfType<{ id: unknown }>(obj, 'id') || !(typeof obj.id === 'string')) {
		return false;
	}
	if (
		!hasPropOfType<{ consumablePath: unknown }>(obj, 'consumablePath') ||
		!(Array.isArray(obj.consumablePath) && isArrayOfType(obj.consumablePath, 'string'))
	) {
		return false;
	}
	if (hasPropOfType<{ chosenOption: unknown }>(obj, 'chosenOption') && !(typeof obj.chosenOption === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ chosenOption__is_null: unknown }>(obj, 'chosenOption__is_null') || !(typeof obj.chosenOption__is_null === 'boolean')) {
		return false;
	}
	if (hasPropOfType<{ choiceDate: unknown }>(obj, 'choiceDate') && !(typeof obj.choiceDate === 'string')) {
		return false;
	}
	if (!hasPropOfType<{ choiceDate__is_null: unknown }>(obj, 'choiceDate__is_null') || !(typeof obj.choiceDate__is_null === 'boolean')) {
		return false;
	}
	if (!hasPropOfType<{ wholePathOnly: unknown }>(obj, 'wholePathOnly') || !(typeof obj.wholePathOnly === 'boolean')) {
		return false;
	}
	if (!hasPropOfType<{ created: unknown }>(obj, 'created') || !(typeof obj.created === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ lastModified: unknown }>(obj, 'lastModified') || !(typeof obj.lastModified === 'number')) {
		return false;
	}
	if (!hasPropOfType<{ shortId: unknown }>(obj, 'shortId') || !(typeof obj.shortId === 'string')) {
		return false;
	}
	return true;
};

export const baseToIndexedDB = (obj: UnambiguationBase): UnambiguationIndexedDb => ({
	id: obj.id.toString(),
	consumablePath: obj.consumablePath.map(tval => tval.toString()),
	chosenOption: typeof obj.chosenOption === 'undefined' ? obj.chosenOption : obj.chosenOption.toString(),
	chosenOption__is_null: typeof obj.chosenOption === 'undefined',
	choiceDate: typeof obj.choiceDate === 'undefined' ? obj.choiceDate : obj.choiceDate.toString(),
	choiceDate__is_null: typeof obj.choiceDate === 'undefined',
	wholePathOnly: obj.wholePathOnly,
	created: obj.created.epochMilliseconds,
	lastModified: obj.lastModified.epochMilliseconds,
	shortId: obj.id.shortString,
});

export const indexedDBToBase = (obj: UnambiguationIndexedDb): UnambiguationBase => ({
	id: UUID.fromString(obj.id),
	consumablePath: obj.consumablePath.map(tval => UUID.fromString(tval)),
	chosenOption: typeof obj.chosenOption === 'undefined' ? obj.chosenOption : UUID.fromString(obj.chosenOption),
	choiceDate: typeof obj.choiceDate === 'undefined' ? obj.choiceDate : Temporal.PlainDate.from(obj.choiceDate),
	wholePathOnly: obj.wholePathOnly,
	created: Temporal.Instant.fromEpochMilliseconds(obj.created),
	lastModified: Temporal.Instant.fromEpochMilliseconds(obj.lastModified),
	objectContext: 'db',
});

export const itdUnambiguation: LocalDatabaseTableDefinition<UnambiguationBase, UnambiguationIndexedDb> = {
	tableName: 'unambiguations',
	indexColumns: ['consumablePath', 'chosenOption', 'choiceDate', 'chosenOption__is_null', 'choiceDate__is_null'],
	convertToIndexed: baseToIndexedDB,
	convertFromIndexed: indexedDBToBase,
};
